/**
 * @name SessionService
 * @description Servicio para los accesos de usuario
 * @author Gabriela Urenda
 */

/**
 * Consulta los permisos que tiene un usuario
 * @param {*} id 
 */
/* const getPermissions = (id = null) => {
    const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
    const permissions = userInfo.Permiso;

    return id !== null ?
}*/

/**
 * Verifica si el usuario tiene los permisos
 * @param {[number]} ids Arreglo de Id's
 */
const hasPermissions = (ids) => {
  const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
  const permissions = userInfo.Permiso;

  return permissions.filter((permission) => { return ids.indexOf(permission.Id) > -1; }).length > 0;
};

/**
 * Consulta los roles que tiene un usuario
 * @param {*} id
 */
/* const getRoles = (id = null) => {
    console.log('getRoles');
    const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
    const roles = userInfo.Rol;
}*/

/** 
 * Verificar si el usuario tiene los roles
 * @param {[number]} ids Arreglo de Id's
 */
const hasRoles = (ids) => {
  const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
  const roles = userInfo.Rol;

  return roles.filter((rol) => { return ids.indexOf(rol.IdRol) > -1; }).length > 0;
};

export const SessionService = {
  hasPermissions,
  hasRoles
};